import React, { FC, IframeHTMLAttributes, useCallback, useState } from "react";
import { createPortal } from "react-dom";

export interface IProps extends IframeHTMLAttributes<HTMLIFrameElement> {
    frameRef: (node: HTMLIFrameElement) => void;
}

export const Frame: FC<IProps> = ({ children, frameRef, ...rest }) => {
    const [iFrameRef, setIFrameRef] = useState<HTMLIFrameElement | null>(null);
    const body = iFrameRef?.contentWindow?.document?.body;

    const handleRef = useCallback(
        (reference: HTMLIFrameElement | null) => {
            // wait for document to be loaded and then set refs
            const intervalId = setInterval(() => {
                if (!["complete", "interactive"].includes(reference?.contentWindow?.document?.readyState)) {
                    return;
                }

                setIFrameRef(reference);
                frameRef(reference);
                clearInterval(intervalId);
            }, 100);
        },
        [frameRef],
    );

    return (
        <iframe ref={handleRef} {...rest}>
            {body && createPortal(children, body)}
        </iframe>
    );
};

export default Frame;
